/* eslint-disable */
/* tslint:disable */
// THIS FILE IS AuTo-GeNeRaTeD BY barrel-rider-sidecar. DO NOT EDIT
// see: https://www.npmjs.com/package/barrel-rider-sidecar
import * as PathFinderWorkerInterface2 from './PathFinderWorkerInterface2'
export { PathFinderWorkerInterface2 }